import Table from "./components/Table";
import Navbar from "./layouts/Navbar";

function App() {
  return (
    <div className="">
      <Navbar />
      <Table />
    </div>
  );
}

export default App;
